const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrayCuate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "348.08 368.15 458.86 368.15 462.42 297.86 344.52 297.86 348.08 368.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.74,330H353.18l-1.35-24.41H452.31ZM354,329.17h95.93l1.45-22.67H352.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.42,358.11H356l-1.09-22h95.9Zm-92.62-.86h91.8l1.27-20.3H355.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.18,320.48H392.5l-.76-5.88h22.2Zm-19.92-.86h19.16l.53-4.16H392.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.18,350H392.5l-.76-5.89h22.2Zm-19.92-.86h19.16L413,345H392.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.44 368.15 362.37 375.81 360.2 391.2 355.97 391.2 355.97 368.15 363.44 368.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.44 368.15 362.37 375.81 355.97 375.81 355.97 368.15 363.44 368.15",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.5 368.15 444.57 375.81 446.74 391.2 450.97 391.2 450.97 368.15 443.5 368.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.5 368.15 444.57 375.81 450.97 375.81 450.97 368.15 443.5 368.15",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.86,
    y: 43.92,
    width: 172.28,
    height: 203.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.25,
    y: 52.09,
    width: 72.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 52.09,
    width: 72.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.25,
    y: 148.98,
    width: 72.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 148.98,
    width: 72.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.86,
    y: 43.92,
    width: 40.81,
    height: 291.8,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.93 57.79 197.24 89.34 197.36 120.89 197.57 183.99 197.36 247.09 197.24 278.64 196.93 310.19 196.61 278.64 196.5 247.09 196.28 183.99 196.5 120.89 196.61 89.34 196.93 57.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.19 65.11 178.5 93.28 178.69 121.45 178.84 177.79 178.69 234.13 178.51 262.3 178.19 290.48 177.87 262.3 177.69 234.13 177.54 177.79 177.69 121.45 177.88 93.28 178.19 65.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.56 71.76 187.87 104.74 187.99 137.73 188.21 203.7 187.99 269.68 187.88 302.66 187.56 335.65 187.24 302.66 187.13 269.68 186.91 203.7 187.13 137.73 187.24 104.74 187.56 71.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.22 59.45 171.54 93.98 171.65 128.5 171.87 197.55 171.65 266.6 171.54 301.12 171.22 335.65 170.91 301.12 170.79 266.6 170.57 197.55 170.79 128.5 170.91 93.98 171.22 59.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.34,
    y: 43.92,
    width: 40.81,
    height: 291.8,
    transform: "translate(631.48 379.63) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.07 57.79 303.39 89.34 303.5 120.89 303.72 183.99 303.5 247.09 303.39 278.64 303.07 310.19 302.75 278.64 302.64 247.09 302.43 183.99 302.64 120.89 302.76 89.34 303.07 57.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.81 65.11 322.13 93.28 322.31 121.45 322.46 177.79 322.31 234.13 322.13 262.3 321.81 290.48 321.49 262.3 321.31 234.13 321.16 177.79 321.31 121.45 321.5 93.28 321.81 65.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.44 71.76 312.76 104.74 312.87 137.73 313.09 203.7 312.87 269.68 312.76 302.66 312.44 335.65 312.12 302.66 312.01 269.68 311.8 203.7 312.01 137.73 312.13 104.74 312.44 71.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.78 59.45 329.09 93.98 329.21 128.5 329.42 197.55 329.21 266.6 329.1 301.12 328.78 335.65 328.46 301.12 328.35 266.6 328.13 197.55 328.35 128.5 328.46 93.98 328.78 59.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 312.92,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 327.03,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.38,
    y: 134.74,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.6,
    y: 148.85,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.89,
    y: 134.74,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 327.03,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.41,
    y: 43.92,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 58.03,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 43.92,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.62 391.27 85.47 391.02 140.31 390.94 250 390.77 359.69 390.94 414.53 391.02 469.38 391.27 414.53 391.51 359.69 391.6 250 391.77 140.31 391.6 85.47 391.51 30.62 391.27",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 434.53,
    rx: 219.38,
    ry: 24.72,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Carpet--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.45,437.66a102.78,102.78,0,0,1-10.66.5,97.52,97.52,0,0,1-10.66-.5,102.78,102.78,0,0,1,10.66-.5A102.78,102.78,0,0,1,61.45,437.66Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.69,434.45A102.91,102.91,0,0,1,54,435a97.4,97.4,0,0,1-10.66-.5A97.4,97.4,0,0,1,54,434,102.91,102.91,0,0,1,64.69,434.45Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.08,431.24a102.65,102.65,0,0,1-10.66.5,102.91,102.91,0,0,1-10.66-.5,97.64,97.64,0,0,1,10.66-.5A102.65,102.65,0,0,1,68.08,431.24Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.35,428a102.91,102.91,0,0,1-10.66.5A102.65,102.65,0,0,1,50,428a97.4,97.4,0,0,1,10.66-.5A97.64,97.64,0,0,1,71.35,428Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.64,424.82a102.91,102.91,0,0,1-10.66.5,102.78,102.78,0,0,1-10.66-.5,97.52,97.52,0,0,1,10.66-.5A97.64,97.64,0,0,1,74.64,424.82Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,421.61a99.88,99.88,0,0,1-10.65.49,100,100,0,0,1-10.66-.49,97.4,97.4,0,0,1,10.66-.5A97.34,97.34,0,0,1,78,421.61Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.22,418.39a97.64,97.64,0,0,1-10.66.5,97.52,97.52,0,0,1-10.66-.5,102.78,102.78,0,0,1,10.66-.5A102.91,102.91,0,0,1,81.22,418.39Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.59,415.18a97.64,97.64,0,0,1-10.66.5,97.52,97.52,0,0,1-10.66-.5,102.78,102.78,0,0,1,10.66-.5A102.91,102.91,0,0,1,84.59,415.18Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.77,412a100,100,0,0,1-10.66.5,97.64,97.64,0,0,1-10.66-.5,102.91,102.91,0,0,1,10.66-.5A102.65,102.65,0,0,1,87.77,412Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.17,408.76a102.78,102.78,0,0,1-10.66.5,97.52,97.52,0,0,1-10.66-.5,100.08,100.08,0,0,1,10.66-.5A102.78,102.78,0,0,1,91.17,408.76Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.46,405.55a102.78,102.78,0,0,1-10.66.5,97.52,97.52,0,0,1-10.66-.5,97.52,97.52,0,0,1,10.66-.5A102.78,102.78,0,0,1,94.46,405.55Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.78,402.34a102.91,102.91,0,0,1-10.66.5,102.65,102.65,0,0,1-10.66-.5,97.4,97.4,0,0,1,10.66-.5A100.2,100.2,0,0,1,97.78,402.34Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.55,437.66a113.89,113.89,0,0,1,21.32,0,97.52,97.52,0,0,1-10.66.5A102.78,102.78,0,0,1,438.55,437.66Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31,434.45A102.91,102.91,0,0,1,446,434a97.4,97.4,0,0,1,10.66.5A97.4,97.4,0,0,1,446,435,102.91,102.91,0,0,1,435.31,434.45Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.92,431.24a102.65,102.65,0,0,1,10.66-.5,97.64,97.64,0,0,1,10.66.5,113.89,113.89,0,0,1-21.32,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.65,428A113.89,113.89,0,0,1,450,428a113.89,113.89,0,0,1-21.32,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.36,424.82a113.89,113.89,0,0,1,21.32,0,113.89,113.89,0,0,1-21.32,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05,421.61a113.78,113.78,0,0,1,21.31,0,116.09,116.09,0,0,1-21.31,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.78,418.39a113.89,113.89,0,0,1,21.32,0,113.89,113.89,0,0,1-21.32,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41,415.18a113.89,113.89,0,0,1,21.32,0,113.89,113.89,0,0,1-21.32,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.23,412a113.89,113.89,0,0,1,21.32,0,97.64,97.64,0,0,1-10.66.5A100,100,0,0,1,412.23,412Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.83,408.76a102.78,102.78,0,0,1,10.66-.5,100.08,100.08,0,0,1,10.66.5,97.52,97.52,0,0,1-10.66.5A102.78,102.78,0,0,1,408.83,408.76Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.54,405.55a102.78,102.78,0,0,1,10.66-.5,97.52,97.52,0,0,1,10.66.5,97.52,97.52,0,0,1-10.66.5A102.78,102.78,0,0,1,405.54,405.55Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.22,402.34a100.2,100.2,0,0,1,10.66-.5,97.4,97.4,0,0,1,10.66.5,113.89,113.89,0,0,1-21.32,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.7 401.91 406.25 401.91 442.88 438.09 57.12 438.09 94.7 401.91",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.15 401.91 63.84 438.09 59.98 438.09 97.56 401.91 101.15 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.65 401.91 74.39 438.09 70.21 438.09 106.29 401.91 109.65 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.5 401.91 92.78 438.09 81.05 438.09 115.03 401.91 124.5 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133 401.91 103.31 438.09 99.14 438.09 129.63 401.91 133 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.82 401.91 121.72 438.09 109.98 438.09 138.37 401.91 147.82 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.32 401.91 132.25 438.09 128.08 438.09 152.96 401.91 156.32 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.17 401.91 150.65 438.09 138.92 438.09 161.69 401.91 171.17 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.66 401.91 161.19 438.09 157.01 438.09 176.3 401.91 179.66 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.5 401.91 179.59 438.09 167.86 438.09 185.04 401.91 194.5 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203 401.91 190.13 438.09 185.95 438.09 199.63 401.91 203 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.84 401.91 208.52 438.09 196.79 438.09 208.37 401.91 217.84 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.33 401.91 219.07 438.09 214.89 438.09 222.97 401.91 226.33 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.17 401.91 237.47 438.09 225.73 438.09 231.71 401.91 241.17 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.67 401.91 248 438.09 243.83 438.09 246.3 401.91 249.67 401.91",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.4 438.09 254.67 438.09 255.04 401.91 264.51 401.91 266.4 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.93 438.09 272.76 438.09 269.63 401.91 273.01 401.91 276.93 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.34 438.09 283.6 438.09 278.38 401.91 287.83 401.91 295.34 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.88 438.09 301.7 438.09 292.97 401.91 296.33 401.91 305.88 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.27 438.09 312.54 438.09 301.72 401.91 311.18 401.91 324.27 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.81 438.09 330.63 438.09 316.31 401.91 319.68 401.91 334.81 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.21 438.09 341.48 438.09 325.05 401.91 334.51 401.91 353.21 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.76 438.09 359.57 438.09 339.64 401.91 343.01 401.91 363.76 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.15 438.09 370.41 438.09 348.38 401.91 357.84 401.91 382.15 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.68 438.09 388.51 438.09 362.98 401.91 366.34 401.91 392.68 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.09 438.09 399.35 438.09 371.72 401.91 381.18 401.91 411.09 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.62 438.09 417.44 438.09 386.32 401.91 389.68 401.91 421.62 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.02 438.09 428.28 438.09 395.06 401.91 404.52 401.91 440.02 438.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.12,
    y: 438.09,
    width: 385.75,
    height: 2.74,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.12,
    y: 438.09,
    width: 385.75,
    height: 2.74,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.1,
    y: 384.5,
    width: 58.19,
    height: 6.61,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.75,
    y: 125.12,
    width: 6.9,
    height: 259.38,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.75,
    y: 125.12,
    width: 6.9,
    height: 34.93,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.69 145.35 46.69 145.35 52 127.92 52.19 127.3 67.62 76.57 98.76 76.57 114.21 127.31 114.21 127.32 114.38 127.89 119.69 145.35",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.21,88.29a.49.49,0,1,1-.49-.49A.49.49,0,0,1,70.21,88.29Zm8.5-.49a.49.49,0,1,0,.49.49A.49.49,0,0,0,78.71,87.8Zm9,0a.49.49,0,1,0,.5.49A.49.49,0,0,0,87.69,87.8Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,96.68,87.8ZM74.21,81.51a.49.49,0,1,0,.49.49A.49.49,0,0,0,74.21,81.51Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,83.2,81.51Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,92.19,81.51ZM60.73,100.87a.49.49,0,1,0,.49.49A.49.49,0,0,0,60.73,100.87Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,69.72,100.87Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,78.71,100.87Zm9,0a.49.49,0,1,0,.5.49A.49.49,0,0,0,87.69,100.87Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,96.68,100.87Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,105.67,100.87ZM65.22,94.58a.49.49,0,1,0,.49.49A.49.49,0,0,0,65.22,94.58Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,74.21,94.58Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,83.2,94.58Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,92.19,94.58Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,101.18,94.58ZM60.73,113.94a.49.49,0,1,0,.49.49A.49.49,0,0,0,60.73,113.94Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,69.72,113.94Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,78.71,113.94Zm9,0a.49.49,0,1,0,.5.49A.49.49,0,0,0,87.69,113.94Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,96.68,113.94Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,105.67,113.94Zm-40.45-6.29a.49.49,0,1,0,.49.49A.49.49,0,0,0,65.22,107.65Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,74.21,107.65Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,83.2,107.65Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,92.19,107.65Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,101.18,107.65Zm-49,19.65-.19.62a.48.48,0,0,0,.23-.42A.45.45,0,0,0,52.19,127.3Zm8.54-.29a.5.5,0,1,0,.49.49A.49.49,0,0,0,60.73,127Zm9,0a.5.5,0,1,0,.49.49A.49.49,0,0,0,69.72,127Zm9,0a.5.5,0,1,0,.49.49A.49.49,0,0,0,78.71,127Zm9,0a.5.5,0,1,0,.5.49A.49.49,0,0,0,87.69,127Zm9,0a.5.5,0,1,0,.49.49A.49.49,0,0,0,96.68,127Zm9,0a.5.5,0,1,0,.49.49A.49.49,0,0,0,105.67,127Zm8.54.31a.48.48,0,0,0,0,.18.45.45,0,0,0,.21.39Zm-58-6.6a.49.49,0,1,0,.49.49A.49.49,0,0,0,56.23,120.72Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,65.22,120.72Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,74.21,120.72Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,83.2,120.72Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,92.19,120.72Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,101.18,120.72Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,110.17,120.72ZM51.74,140.08a.5.5,0,1,0,.49.5A.49.49,0,0,0,51.74,140.08Zm9,0a.5.5,0,1,0,.49.5A.49.49,0,0,0,60.73,140.08Zm9,0a.5.5,0,1,0,.49.5A.49.49,0,0,0,69.72,140.08Zm9,0a.5.5,0,1,0,.49.5A.5.5,0,0,0,78.71,140.08Zm9,0a.5.5,0,1,0,.5.5A.49.49,0,0,0,87.69,140.08Zm9,0a.5.5,0,1,0,.49.5A.49.49,0,0,0,96.68,140.08Zm9,0a.5.5,0,1,0,.49.5A.49.49,0,0,0,105.67,140.08Zm9,0a.5.5,0,1,0,.49.5A.49.49,0,0,0,114.66,140.08Zm-58.43-6.29a.49.49,0,1,0,.49.49A.49.49,0,0,0,56.23,133.79Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,65.22,133.79Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,74.21,133.79Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,83.2,133.79Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,92.19,133.79Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,101.18,133.79Zm9,0a.49.49,0,1,0,.49.49A.49.49,0,0,0,110.17,133.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,280.67c-3.8-3.72-8.71-8.22-14.51-6.62-5.47,1.51-7.56,7.48-8.54,12.45-1.26,6.4-2.24,12.87-3.26,19.31s-2,13-2.92,19.56q-.79,5.52-1.57,11c-.26,1.84-.51,3.69-.77,5.53s-.55,3.61-.65,5.43c0,.58.88.67,1,.11.7-3.07,1-6.26,1.44-9.38s.91-6.27,1.37-9.41q1.37-9.33,2.79-18.67t2.9-18.67c.84-5.27,1.24-11.82,5.92-15.3a9,9,0,0,1,8.74-.82c3.08,1.17,5.53,3.37,7.94,5.55A.08.08,0,0,0,448,280.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.78,276.86s-7.76-2.79-11.59,2.88.74,20.07,36.1,28.21a99.9,99.9,0,0,0-8.51-32C451.2,259.46,437.7,265.72,442.78,276.86Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.25,305.59a27.31,27.31,0,0,0-1.77-2.87c-.6-.91-1.19-1.82-1.8-2.72-.45-.68-.92-1.35-1.38-2,0-.17,0-.34.07-.51l.12-.92c.08-.66.18-1.32.28-2s.2-1.32.33-2a11.18,11.18,0,0,1,.46-2.08c.05-.1-.14-.15-.15,0a7,7,0,0,1-.32,1.17c-.08.3-.16.59-.23.89-.18.67-.34,1.35-.49,2s-.26,1.25-.36,1.88c-.06.3-.1.6-.14.91-.63-.9-1.27-1.79-1.94-2.67-1.87-2.47-3.86-4.85-5.91-7.17a.15.15,0,0,0,0-.07c.18-3.71.09-7.39.92-11,0-.1-.13-.15-.15,0a37.31,37.31,0,0,0-1.32,10.56c-.74-.82-1.49-1.64-2.24-2.45q-2.58-2.77-5.27-5.46a.08.08,0,0,0-.11.11c3,3.21,5.8,6.55,8.56,9.95a60.45,60.45,0,0,0-6.46.24c-2.4.18-4.78.48-7.16.81a.08.08,0,0,0,0,.16,68.54,68.54,0,0,1,7.15-.64c2.3-.1,4.6,0,6.9,0,1.49,1.85,3,3.7,4.41,5.58H457c-.55,0-1.09,0-1.63,0-1.07,0-2.15.09-3.22.18a49.7,49.7,0,0,0-6.53,1,.08.08,0,0,0,0,.15c2.18-.24,4.35-.45,6.54-.52,1,0,2.08,0,3.12,0h1.63a2,2,0,0,0,.89-.09c.95,1.24,1.91,2.47,2.85,3.71.75,1,1.49,2,2.21,3s1.42,2.15,2.25,3.11C465.19,305.75,465.29,305.67,465.25,305.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.16,284.89a23.82,23.82,0,0,0-3.78-.18c-1.26,0-2.52,0-3.78.08a.08.08,0,1,0,0,.16c1.28-.09,2.55-.11,3.84-.1s2.47.14,3.71.11C446.2,285,446.2,284.9,446.16,284.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.26,287.74c.14-1.2.29-2.42.55-3.61a.08.08,0,1,0-.15,0c-.18,1.19-.42,2.37-.59,3.56-.09.59-.17,1.19-.24,1.79a7.9,7.9,0,0,0-.15,1.68.11.11,0,0,0,.21,0,10.53,10.53,0,0,0,.18-1.68C457.13,288.89,457.19,288.32,457.26,287.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.93,274.37c-.31,1.17-.61,2.36-.83,3.56-.11.6-.2,1.21-.29,1.82a7.7,7.7,0,0,0-.11,1.79s.07,0,.09,0a10.89,10.89,0,0,0,.28-1.71c.08-.58.17-1.17.27-1.75.21-1.24.43-2.46.74-3.67A.08.08,0,0,0,454.93,274.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.9,346.07c-.2-2.23-.41-4.45-.65-6.68-.46-4.4-1-8.79-1.59-13.18s-1.15-8.76-1.86-13.12a32.74,32.74,0,0,0-1.34-6,5.66,5.66,0,0,0-3.3-3.72c-4.16-1.44-7,2.87-8.65,5.93-.05.09.08.16.14.07,1-1.44,3.79-5.5,6.94-5.31,2.13.13,3.82,1.63,4.84,6.92,2.54,13.19,4.83,40,5.1,41.71.14.93.8.89.8-.1C409.34,350.44,409.09,348.25,408.9,346.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.63,307.69s3.64-12.83-4.4-6.41C374.85,312,374.38,335.2,374.38,335.2s23.78-13.81,26.74-22.92C405.52,298.71,392.63,307.69,392.63,307.69Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.14,314c-1.87.37-3.76.62-5.65.89l-2.67.38-1.82.21c1.77-2.44,3.55-4.87,5.25-7.36.07-.09-.08-.19-.16-.11a54.3,54.3,0,0,0-4,4.58c-.35-1-.71-2-1.06-3-.4-1.15-.83-2.29-1.13-3.47a.08.08,0,0,0-.15,0c.33,1.18.56,2.38.87,3.56s.65,2.26,1.05,3.37c-.87,1.13-1.7,2.29-2.52,3.46-.4-1.16-.91-2.28-1.27-3.46,0-.1-.19-.05-.15.05.42,1.3.65,2.66,1.05,4-.54.79-1.09,1.59-1.61,2.4-1,1.48-1.87,3-2.75,4.51a.35.35,0,0,0-.21.36c-1.5,2.6-2.93,5.24-4.34,7.9a.08.08,0,0,0,.14.08c1.41-2.63,3-5.19,4.61-7.7h0a4.5,4.5,0,0,1,.78-.15l.82-.18c.61-.13,1.22-.29,1.83-.44,1.21-.3,2.4-.58,3.63-.8.1,0,0-.17-.05-.15-1.44.28-2.88.44-4.34.61-.68.08-1.37.17-2,.27l-.1,0c.86-1.3,1.72-2.59,2.6-3.87s1.75-2.49,2.65-3.72c.82-.12,1.64-.33,2.46-.49l2.76-.54c1.84-.36,3.67-.77,5.52-1.08C397.28,314.13,397.24,314,397.14,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.84,315.26c-.11-.34-.21-.68-.32-1a19.88,19.88,0,0,1-.54-2.15c0-.1-.18-.06-.16,0,.16.73.33,1.45.49,2.17a15.87,15.87,0,0,0,.62,2.14.15.15,0,0,0,.28-.09C383.11,316,383,315.63,382.84,315.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.57,311c-1.09.17-2.18.24-3.27.34s-2.18.25-3.27.41c-.06,0-.06.1,0,.1,1.1-.08,2.18-.16,3.27-.31s2.18-.3,3.27-.38C399.68,311.18,399.67,311,399.57,311Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.4,329.81c-.42-9.45-1-18.88-2-28.3-.48-4.68-1-9.37-1.66-14a101,101,0,0,0-2.71-13.58,26,26,0,0,0-4.53-9.58,10.23,10.23,0,0,0-9.13-4c-4.14.51-7.47,3.11-10.35,5.95-3.24,3.17-6.19,6.64-9.19,10-.76.86-1.51,1.72-2.25,2.59-.07.08.05.19.11.11,2.93-3.36,6-6.63,9.15-9.75,2.94-2.89,6-6,10.05-7.23a10.24,10.24,0,0,1,5.83-.14,9.28,9.28,0,0,1,4,2.52,20.91,20.91,0,0,1,4.49,8.74c2.54,8.69,3.45,17.8,4.4,26.77s1.6,18.26,2.06,27.41.82,18.42,1.71,27.59c.11,1.13.26,2.26.4,3.39.1.76,1.27.76,1.21,0C427.26,348.8,426.82,339.31,426.4,329.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.53,267.29s5.39-10-1-13.19-27.73,20.62-34,55.46c0,0,34.47-15.25,46.18-30.45S405.2,260.56,395.53,267.29Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.6,275.41c-3.88,0-7.74-.29-11.62-.26l2.18-2.5a33.69,33.69,0,0,0,3-3.52c.06-.08-.06-.19-.14-.13a29,29,0,0,0-2.93,2.94c-1,1-1.93,2.07-2.9,3.11-1.48,1.6-2.93,3.23-4.38,4.86v-2.5c0-1.32,0-2.63,0-4,0-2.66,0-5.34.21-8,0-.1-.16-.09-.16,0-.19,2.67-.46,5.33-.6,8-.06,1.31-.09,2.62-.11,3.94,0,.68,0,1.36,0,2,0,.37,0,.76,0,1.14l-.69.76c-3.09,3.53-6,7.19-8.89,10.9,0-.2,0-.41,0-.61,0-.41-.09-.82-.14-1.23-.1-.89-.22-1.78-.35-2.66s-.26-1.66-.4-2.49-.38-1.88-.46-2.82c0-.11-.18-.09-.15,0a24.51,24.51,0,0,1,.32,2.83l.24,2.56c.07.86.15,1.71.24,2.56l.12,1.23c0,.21.05.41.08.62a1.28,1.28,0,0,0,.16.48l-1.47,1.93c-2,2.59-3.87,5.2-5.79,7.81-.06.09.05.2.11.11,1.82-2.37,3.69-4.69,5.59-7,1.41.06,2.86,0,4.28-.07s3,0,4.49,0c.1,0,.09-.17,0-.16-1.49,0-3,0-4.48,0s-2.76-.06-4.12,0c1.67-2,3.35-4,5-6l1.85-2.2a8.33,8.33,0,0,0,1.73.06h2l3.82-.06c2.63,0,5.26-.13,7.9-.13.1,0,.09-.16,0-.16-2.63,0-5.27-.15-7.9-.21-1.28,0-2.55-.08-3.83-.09l-2,0c-.39,0-.79,0-1.18,0l4.34-5.14a.16.16,0,0,0,.08-.1c1.41-1.66,2.83-3.33,4.26-5,.19-.23.39-.45.59-.68,4,.13,8-.14,12-.06A.08.08,0,0,0,400.6,275.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.61,282.26h-.94c-.09,0-.08.14,0,.14h.94C398.72,282.42,398.72,282.26,398.61,282.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.53,282.27c-1.24,0-2.49,0-3.73-.07l-1.86-.06a6.68,6.68,0,0,0-1.73,0c-.06,0,0,.1,0,.11a6.75,6.75,0,0,0,1.74.13l1.86,0c1.24,0,2.48,0,3.72,0C396.63,282.43,396.63,282.28,396.53,282.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.69,293.91a52.64,52.64,0,0,0-7.62-.69s0,0,0,.06c2.53.24,5.07.38,7.58.78C385.75,294.08,385.79,293.92,385.69,293.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.33,282.82c0-.22-.05-.45-.08-.67-.07-.5-.15-1-.22-1.49-.15-1-.32-1.89-.5-2.83,0-.09-.17-.07-.16,0,.12,1,.23,1.95.32,2.93l.12,1.44a4,4,0,0,0,.2,1.37c.07.14.29.08.33-.06A1.89,1.89,0,0,0,375.33,282.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.06,254.46c-1.23-2.3-2.8-5.33-5.88-5.14-2.55.16-3.69,2.76-4.24,4.9-1.68,6.64-1.79,13.63-2.12,20.43-.69,14.37-1.31,28.76-1.4,43.14q0,6,0,12c0,4.06,0,8.16.29,12.22a.3.3,0,0,0,.59,0c0-3.48-.1-7-.11-10.44s0-6.79.07-10.18q.17-10.32.55-20.63c.25-6.83.55-13.66.84-20.49q.21-5.12.44-10.24c.15-3.3.29-6.61.67-9.9.21-1.84.49-3.69.87-5.5a7.79,7.79,0,0,1,1.59-3.69,3.48,3.48,0,0,1,4.5-.32,9.46,9.46,0,0,1,3.18,4C426,254.64,426.11,254.55,426.06,254.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.23,253.36s-2.54-8.94,3.06-4.47c9.32,7.45,9.65,23.64,9.65,23.64s-16.56-9.63-18.62-16C416.25,247.1,425.23,253.36,425.23,253.36Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.46,265.89l-.47-.73a5,5,0,0,0,0-.77c0-.38,0-.77,0-1.15,0-.76,0-1.51.08-2.27,0-.1-.15-.09-.16,0q-.06,1.11-.09,2.22c0,.37,0,.74,0,1.11,0,.15,0,.31,0,.48-.65-1-1.32-2-2-3-.2-.29-.41-.56-.61-.85a17.78,17.78,0,0,1-.05-2.92c0-1,0-2.07.06-3.11,0-.11-.15-.1-.16,0,0,1.08-.08,2.16-.14,3.24a22.46,22.46,0,0,0-.06,2.32c-1.6-2.18-3.3-4.28-5-6.36-.06-.07-.18,0-.13.1,1.07,1.34,2.09,2.72,3.09,4.12-2-.45-3.94-.72-5.92-1-.1,0-.14.14,0,.15,2.1.32,4.16.85,6.23,1.3h0c.79,1.11,1.58,2.24,2.36,3.36.32.46.62.93.94,1.39h-.09c-.22,0-.43-.07-.65-.09-.45-.06-.91-.09-1.37-.13-1-.08-1.92-.13-2.87-.18a.08.08,0,0,0,0,.16c.94,0,1.88.1,2.82.2l1.48.18.65.07.19,0,1.59,2.35c.93,1.38,1.77,2.86,2.77,4.2a.08.08,0,0,0,.13-.08A42.84,42.84,0,0,0,434.46,265.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.33,255.79c0-.35,0-.7,0-1a16.11,16.11,0,0,1,.09-2.19.08.08,0,1,0-.16,0c0,.72-.08,1.44-.12,2.17,0,.36,0,.72,0,1.08v.5a1.51,1.51,0,0,0,0,.52.07.07,0,0,0,.14,0,1.54,1.54,0,0,0,0-.48C430.33,256.15,430.33,256,430.33,255.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,259.49c-.61-.1-1.24-.13-1.87-.19s-1.36-.12-2-.2a.08.08,0,1,0,0,.15c1.31.09,2.61.32,3.92.37C428.34,259.62,428.35,259.5,428.28,259.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.49,259.55c.05.06,0,.26,0,.34v.92c0,.2,0,.41,0,.62a1.44,1.44,0,0,0,0,.55s.06,0,.07,0a.58.58,0,0,0,0-.26v-.29c0-.21,0-.42,0-.63v-.91c0-.09,0-.27,0-.35S433.38,259.4,433.49,259.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.44,302.17c-3.48-2.61-6.61-6.37-11.29-6.55-3.87-.15-6.58,2.76-8.13,6a33.57,33.57,0,0,0-1.9,5.34q-1,3.68-2,7.38c-1.22,4.85-2.26,9.76-3.1,14.69-.48,2.75-.91,5.52-1.26,8.29a71,71,0,0,0-.82,8.48.44.44,0,0,0,.87.09c.47-2.32.67-4.71,1-7.05s.7-4.7,1.1-7c.79-4.69,1.71-9.37,2.77-14,1-4.38,2-8.83,3.4-13.1,1-3.06,2.64-6.63,5.94-7.73,5-1.68,9.6,2.58,13.27,5.34C426.42,302.35,426.53,302.24,426.44,302.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.84,299.67s-3.21-9.17,1.43-11c7-2.69,25.18,17.83,21.62,49.27,0,0-14.08-7.75-24.47-16.48s-13.06-20.11-8.48-23.06S422.84,299.67,422.84,299.67Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.78,331.23a23.55,23.55,0,0,0-1.69-3.17c-.59-1.07-1.2-2.15-1.82-3.21-1.21-2.07-2.41-4.14-3.65-6.19-.2-.33-.41-.66-.61-1,0-.12.05-.24.08-.36.07-.31.14-.61.2-.91.16-.69.28-1.37.41-2.06.25-1.35.48-2.71.85-4a.08.08,0,0,0-.16,0c-.29,1.35-.71,2.67-1.11,4-.2.65-.41,1.3-.58,1.95l-.17.68c-1.5-2.46-3-4.9-4.66-7.26a3.62,3.62,0,0,0,.16-1c.05-.46.1-.92.16-1.37.12-1,.24-2.07.39-3.1a58.66,58.66,0,0,1,1.11-6c0-.1-.14-.12-.16,0-.5,2-1,4-1.42,6-.19,1-.36,2-.5,3-.06.49-.11,1-.16,1.49l-.06.45c-.51-.71-1-1.42-1.54-2.12-1.61-2.11-3.27-4.18-5-6.24-.06-.08-.19,0-.13.09a111,111,0,0,1,7.92,11.57c.46.73.91,1.48,1.37,2.22l-.45-.06c-.59-.07-1.19-.11-1.78-.16-1.18-.11-2.37-.22-3.55-.31-2.38-.19-4.75-.34-7.12-.59a.08.08,0,0,0,0,.16c2.4.27,4.79.66,7.17,1l3.53.47a14.06,14.06,0,0,0,2.71.28q1.41,2.26,2.8,4.54c-.21,0-.42,0-.63,0h-3.39c-1.53,0-3.05,0-4.58,0-.1,0-.09.16,0,.16,1.54,0,3.09.1,4.63.18.74,0,1.47.08,2.2.13l1.1.08a2.27,2.27,0,0,0,1,0l2.37,3.86c.73,1.19,1.47,2.38,2.22,3.55a28.23,28.23,0,0,0,2.39,3.58A.09.09,0,0,0,443.78,331.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.08,305.82a23.36,23.36,0,0,1-.63,3c-.26,1-.56,2-.89,3a.1.1,0,1,0,.19.06q.47-1.48.84-3c.24-1,.4-2,.64-3C437.26,305.75,437.09,305.72,437.08,305.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.73,312a1.15,1.15,0,0,0-.76-.28l-1.33-.19-2.48-.3c-1.71-.2-3.43-.36-5.15-.58-.1,0-.13.15,0,.16,1.61.2,3.22.44,4.84.65.79.11,1.58.22,2.38.31l1.14.13a4.14,4.14,0,0,1,1.31.22C426.73,312.12,426.79,312,426.73,312Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,325.79c-.81-.07-1.62-.09-2.44-.12l-1.23,0-.59,0a3.23,3.23,0,0,1-.76,0c-.12,0-.13.18,0,.16a3.47,3.47,0,0,1,.72,0l.64,0,1.23.07c.81.05,1.62.1,2.43.1A.09.09,0,0,0,437.05,325.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,322.27c.1-.46.18-.92.27-1.38.17-.91.33-1.81.5-2.72a.08.08,0,0,0-.16,0l-.6,2.65c-.1.44-.19.88-.29,1.33l-.12.61a1.6,1.6,0,0,0-.08.65c0,.07.13.13.18.05A3.21,3.21,0,0,0,442,322.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.35 342.28 395.33 353.42 398.66 391.06 428.13 391.06 432.3 353.42 433.52 342.28 394.35 342.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.35 342.28 395.33 353.42 432.3 353.42 433.52 342.28 394.35 342.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.43,
    y: 339.24,
    width: 45.01,
    height: 9.04,
    transform: "translate(827.88 687.52) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.5,410.55c.26,3.45-9.61,4.44-13.72,2.2-1.31-.71-5-3.83-9.5-7.8-9.89-8.75-23.57-21.55-23.57-21.55L302.58,388l-41.41,16-29-53.51s23.95-10.13,46.72-19.2c3.5-1.39,7-2.74,10.32-4.05l.62-.25c15.28-5.87,27.94-10.32,29.24-9.41C322.6,319.94,359.24,407.07,359.5,410.55Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.5,410.55c.26,3.45-9.61,4.44-13.72,2.2-1.31-.71-5-3.83-9.5-7.8,10.27-1.38-39.65-69-46.42-78,15.28-5.87,27.94-10.32,29.24-9.41C322.6,319.94,359.24,407.07,359.5,410.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.57,398S186,422.65,146.38,415.52c-18.94-3.41-32.61-27.79-23.51-46.46,8.5-17.42,60.44-35.1,75.11-45.35,4.63-3.21,4.13-15.95,4.13-15.95l38.55-.52s13.74,21.83,7.92,32.46a4.53,4.53,0,0,1-.33.53l17.39-6.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,368.85c-4.29-9.32-9-18.43-13.36-27.71-.08-.18-.37-.08-.29.1,4.12,9.35,7.92,18.84,12.21,28.12s8.93,18.45,13.43,27.67c.12.24.5.11.39-.14C278,387.55,274,378.14,269.75,368.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.5,340.68c-2.65,1.54-5.19,3.34-7.77,5S235.62,349,233,350.5c-5.26,3.13-10.65,6.05-16.09,8.84A276.09,276.09,0,0,1,183,374c-6.49,2.28-13.05,4.51-19.72,6.17-.15,0-.08.26.07.22,4.86-1.16,9.72-2.31,14.52-3.66-2.55,1.6-5.05,3.28-7.58,4.9a.12.12,0,0,0,.12.2c2.77-1.67,5.58-3.28,8.33-5a.27.27,0,0,0,.08-.39c.82-.24,1.64-.46,2.46-.72,5.94-1.84,11.82-3.9,17.59-6.24a216.36,216.36,0,0,0,32.9-16.63q4.43-2.74,8.75-5.65a80.57,80.57,0,0,0,8.3-6.15C249,340.85,248.72,340.55,248.5,340.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.8,423.77c.26,3.45-9.61,4.44-13.72,2.2-1.31-.71-5-3.83-9.5-7.8-9.89-8.75-23.57-21.55-23.57-21.55l-10.13,4.56-41.41,16-29-53.51s23.95-10.13,46.72-19.2c3.5-1.39,7-2.74,10.32-4.05l.62-.25c15.28-5.88,27.94-10.32,29.24-9.41C363.9,333.16,400.54,420.29,400.8,423.77Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.8,423.77c.26,3.45-9.61,4.44-13.72,2.2-1.31-.71-5-3.83-9.5-7.8,10.27-1.38-39.65-69-46.42-78,15.28-5.88,27.94-10.32,29.24-9.41C363.9,333.16,400.54,420.29,400.8,423.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.37,307.51l66.28-1s14.06,35.78,8.24,46.42S223,378.77,223,378.77l83.93-31.93,27.93,64.32s-102,22.24-156.16,16.72c-20.31-2.07-33.06-28.6-21.16-49,12.51-21.45,57.93-50.79,57.93-50.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.76,346.68c-25.69,11.74-51.61,23-78.11,32.74q-5.52,2-11.06,4c-3.83,1.38-7.63,3-11.55,4.06-.19.05-.09.36.09.29,3.38-1.26,6.89-2.17,10.31-3.29s6.71-2.21,10-3.38l4.31-1.52-.87.59c-1.32.89-2.64,1.77-3.94,2.69-2.68,1.88-5.18,4.12-8,5.8-.17.1,0,.38.16.26,2.68-1.9,5.69-3.32,8.44-5.11,1.34-.87,2.64-1.78,3.94-2.7a26.82,26.82,0,0,0,3.46-2.67q6.33-2.27,12.62-4.64,19.8-7.56,39.11-16.27c7.19-3.26,14.32-6.64,21.35-10.22C305.44,347.15,305.14,346.5,304.76,346.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.53,381.5c-4.28-9.32-9-18.43-13.36-27.71-.08-.17-.37-.08-.29.11,4.12,9.35,7.92,18.84,12.21,28.12s8.93,18.45,13.43,27.67c.12.23.5.11.39-.14C320.76,400.21,316.8,390.79,312.53,381.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.28,328.8a180.78,180.78,0,0,0-20.93,13.89c-6.65,4.93-13.09,10.14-19.23,15.69-3.1,2.8-6.09,5.73-9,8.74a67.16,67.16,0,0,0-7.62,9.21A32.34,32.34,0,0,0,152,396.55a34.27,34.27,0,0,0,2.63,11.05,40.64,40.64,0,0,0,6.14,9.48c.09.11.26-.06.16-.17a26,26,0,0,1-5.18-9.07,34.2,34.2,0,0,1,2.59-29.18c4.07-6.75,10-12.35,15.73-17.73a239.72,239.72,0,0,1,18.44-15.69c3.59-2.77,7.25-5.45,10.93-8.09s7.46-5.18,11.06-7.94A.24.24,0,0,0,214.28,328.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.55,331.47c-5.39-1.88-11.28-2.62-16.94-3.25s-11.3-.92-17-1a.12.12,0,0,0,0,.24c5.76.5,11.51,1.23,17.22,2.09,5.53.83,11.07,2,16.64,2.47C233.82,332,233.82,331.56,233.55,331.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.62,332.25a79.7,79.7,0,0,1-10.56-1c-2.9-.41-5.87-.84-8.28-2.65-4.7-3.52-6.61-9.72-7.61-15.26,0-.13-.24-.09-.23,0,.81,6,1.08,12.94,6.37,17,2.61,2,5.77,2.61,9,2.81a55.62,55.62,0,0,0,11.31-.7A.13.13,0,0,0,278.62,332.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91,341.8a69.82,69.82,0,0,0-1.86-10.34c-.83-3.5-1.82-6.95-2.93-10.37-1.26-3.88-2.71-7.69-4.24-11.48-.06-.13-.27-.07-.23.07,2.19,6.4,4.19,12.88,5.85,19.44.83,3.25,1.56,6.52,2.22,9.8a20.36,20.36,0,0,1,.06,9.63,16.9,16.9,0,0,1-5.31,8.26s0,.07,0,.05A17.32,17.32,0,0,0,285.91,341.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.25,361.46c-4.47,1.17-8.85,2.71-13.25,4.13s-8.8,2.86-13.19,4.32c-8.79,2.93-17.54,6-26.29,9-5,1.72-9.9,3.55-14.84,5.35a.12.12,0,0,0,.07.23q26.52-8.24,52.72-17.48c4.95-1.74,10-3.35,14.83-5.37C297.39,361.58,297.36,361.43,297.25,361.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,281.57a64.21,64.21,0,0,1-11.92,8.33c6.08-11.66,3.69-37.11,3.07-33.43-3,17.61-12.88,37.25-17,38.42h-.07c-11.1,2.06-21.41-.41-30.14-4.68a.14.14,0,0,1,0-.06c7.94-13.24,6.19-39.16,5.69-37.55-5.42,17.26-18,27.86-20.24,27.95h0c-8.83-7.57-13.71-15.35-12.56-16.23,8.39-6.39,15-22,20.8-38.55h0c5.76-16.27,8.28-31.58,16.81-46.28,7.82-13.46,24.69-16.84,34.68-10.72C248.37,184.83,238.19,277.05,233,281.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.38,167.82a17,17,0,0,1,5.85,4.29,41.14,41.14,0,0,1,4.44,5.81,69.14,69.14,0,0,1,6.12,13.28,109.39,109.39,0,0,1,5.54,28.65,172.08,172.08,0,0,1-.77,29.16c-.24,2.42-.62,4.83-.93,7.24l-1.14,7.19-1.42,7.15-1.62,7.09,1.19-7.17,1.05-7.19.91-7.21c.23-2.41.54-4.8.7-7.22a187.6,187.6,0,0,0,.43-28.93,115.87,115.87,0,0,0-5.08-28.38A69.87,69.87,0,0,0,230,178.31a39.61,39.61,0,0,0-4.1-5.93,23.52,23.52,0,0,0-2.54-2.55A11.85,11.85,0,0,0,220.38,167.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.71,261.76c2.48-3.39,4.74-6.94,6.87-10.55s4.19-7.27,6-11,3.57-7.56,5.06-11.47,2.84-7.89,4.28-11.84c2.94-7.88,5.87-15.78,9.28-23.49,1.72-3.85,3.51-7.67,5.56-11.37a57.29,57.29,0,0,1,3.38-5.35,15.26,15.26,0,0,1,4.45-4.46,16.47,16.47,0,0,0-4.09,4.7,56.36,56.36,0,0,0-3,5.49c-1.89,3.73-3.54,7.59-5.12,11.48-3.15,7.77-6.08,15.64-8.9,23.55-1.48,3.94-2.87,7.89-4.43,11.83a107,107,0,0,1-5.33,11.5A120.6,120.6,0,0,1,148.71,261.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.64,242.39c-7.85,21.63-39.92,60.69-49.92,61.95-2.7.34-12.39-.85-16.44-4.1-8.2-6.59-15.93-32.7-19.45-55.21-1.14-7.3,29.06-8.42,35.67-4.25,2.55,1.61,3.93,20.36,5.18,19.83,6.39-2.72,29.78-23.22,33.61-26.18C216.63,225.64,219.59,234.26,216.64,242.39Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,250.52c-3-8.1-2-26.07,0-37.22,1-5.91,6.09-21.85,9.39-21.69,3,.14,3.06,5.29,3.06,5.29s3.52-7.45,6.36-7c4.15.64,2.35,7.86,2.35,7.86s2.59-7.1,6.75-6.51,2.16,8.38,2.16,8.38,2.11-6.61,5.32-4.53c3.86,2.51-1.25,14.24-1.32,20.87,0,1.5-3.32,28.87-3.32,28.87Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,196.92a70.51,70.51,0,0,0-2.9,20.13c0,1.93.07,3.87.08,5.81,0,.07.11.06.11,0a99,99,0,0,1,.85-10.19c.38-3.34.89-6.66,1.32-10,.25-1.89.55-3.78.82-5.67C144.57,196.85,144.32,196.76,144.27,196.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,197.51c-.48,1.51-.91,3-1.24,4.57s-.62,3.23-.83,4.87a83.4,83.4,0,0,0-.68,9.6c0,1.85.1,3.69.18,5.54,0,.12.2.1.2,0,0-3.2.35-6.43.65-9.62s.74-6.31,1.2-9.45c.26-1.8.51-3.61.76-5.41C153.28,197.44,153.07,197.37,153,197.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.09,199.32a70.9,70.9,0,0,0-2.6,10.88,95.07,95.07,0,0,0-1.18,11.31c0,.08.11.1.12,0,.67-3.69,1.27-7.4,2-11.09s1.3-7.37,1.82-11.08C162.22,199.29,162.11,199.25,162.09,199.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.55,246.75s6.11-9.23,6.85-14.28-2.92-23.66-6.94-22.26c-5.19,1.81-5.17,13.41-4.46,18.95,0,0-12,4.18-13.71,12.85S168.55,246.75,168.55,246.75Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.1,211.19c-4.25,5.14-2.86,12.25-2.56,17.76a.61.61,0,0,1-.6.67c-5,2.09-11.72,6.51-13.83,12.13-.06.17-.28.14-.23,0,1.54-6.21,7.92-11.07,13.46-13-.4-5.62-1.49-12.89,3.73-17.56C167.1,211.12,167.13,211.15,167.1,211.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,242.39c-3.58,13.05-21.58,38.49-21.58,38.49l-5.79-6.22-19.16-20.55s29.09-21,38.57-26.23C221.52,223.18,224.05,231.16,221,242.39Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,274.52c-3.33-3.84-17.51-19.09-20.8-22.18-.23-.22-.42-.13-.21.12,9.69,11.75,17.4,18.57,20.85,22.18C202,274.73,202.1,274.62,202,274.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.31,245.83a13.31,13.31,0,0,0-3.28-.14,13.22,13.22,0,0,0,3.15.88,13.7,13.7,0,0,0,3.27.16A12.1,12.1,0,0,0,194.31,245.83Zm-8.9,16a12.69,12.69,0,0,0-2.22-2.42,13.23,13.23,0,0,0,1.6,2.85,13.38,13.38,0,0,0,2.22,2.42A13,13,0,0,0,185.41,261.82Zm25.71-19.64a13.78,13.78,0,0,0-2.22-2.43,13,13,0,0,0,1.61,2.87,12.56,12.56,0,0,0,2.21,2.41A13.23,13.23,0,0,0,211.12,242.18Zm-6.49,19.6a12.89,12.89,0,0,0-2.41,2.21,13.3,13.3,0,0,0,2.86-1.6,13,13,0,0,0,2.42-2.22A12.77,12.77,0,0,0,204.63,261.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,242.39c-3.59,13.06-21.58,38.49-21.58,38.49l-5.79-6.21-6.79-7.28,30.37-40.87C222.27,226.29,223.47,233.27,221,242.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,253.79c-.6,2.28-1.08,4.65-1.46,7a2.45,2.45,0,0,1,0-.27c-.08-1.32-.13-2.68-.32-4,0-.07-.12-.09-.13,0a20.87,20.87,0,0,0,0,4c.06.63.11,1.27.19,1.9-.15,1.06-.28,2.13-.38,3.19-.19,2-.87,10.6-.88,12.08,0,.31.36.35.44,0,.35-1.51,1.42-10.35,1.7-12.34a107.92,107.92,0,0,0,1-11.64C203.18,253.7,203,253.71,203,253.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.76,323.48s31.83,5.26,90.82-4c0,0-28.31-72.46-48.38-91.14-9.13-8.5-17.35-6.54-24-.21-1.65,1.58-21.53,30.74-22.72,40.5-1,8.63,6.54,17.61,6.54,17.61Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,252.64a13.28,13.28,0,0,1-.15,3.28,12.26,12.26,0,0,1-.89,3.15,13.18,13.18,0,0,1,.15-3.27A13.32,13.32,0,0,1,221.44,252.64Zm1.92,41.47a12.72,12.72,0,0,0-.15,3.27,12.79,12.79,0,0,0,.89-3.15,13.28,13.28,0,0,0,.15-3.28A12.87,12.87,0,0,0,223.36,294.11Zm30.44-18.53a12.72,12.72,0,0,0-.15,3.27,13.11,13.11,0,0,0,.89-3.15,12.74,12.74,0,0,0,.14-3.27A12.65,12.65,0,0,0,253.8,275.58Zm-51.94,10.06a12.72,12.72,0,0,0-.15,3.27,13.11,13.11,0,0,0,.89-3.15,13.28,13.28,0,0,0,.14-3.28A12.84,12.84,0,0,0,201.86,285.64Zm35.41-23.26a13.18,13.18,0,0,0-3.27-.15,12.26,12.26,0,0,0,3.15.89,13.28,13.28,0,0,0,3.28.15A13.32,13.32,0,0,0,237.27,262.38Zm18.21,32.23a12.82,12.82,0,0,0-3.28-.15,13.32,13.32,0,0,0,3.16.89,12.72,12.72,0,0,0,3.27.14A12.65,12.65,0,0,0,255.48,294.61Zm-38.29,17.08a13.28,13.28,0,0,0-3.28-.15,12.44,12.44,0,0,0,3.16.89,13.18,13.18,0,0,0,3.27.15A13.38,13.38,0,0,0,217.19,311.69Zm41.05,2.12a12.72,12.72,0,0,0-3.27-.14,14.49,14.49,0,0,0,6.43,1A13.32,13.32,0,0,0,258.24,313.81Zm-32.66-85.15a12.72,12.72,0,0,0-3.27-.15,14.12,14.12,0,0,0,6.43,1A12.84,12.84,0,0,0,225.58,228.66Zm15.28,9.71a12.92,12.92,0,0,0,2.21,2.41,12.23,12.23,0,0,0-1.6-2.85,13.29,13.29,0,0,0-2.21-2.42A13.3,13.3,0,0,0,240.86,238.37Zm27.72,41.21a12.61,12.61,0,0,0,2.21,2.42,13.3,13.3,0,0,0-1.6-2.86,13,13,0,0,0-2.22-2.42A12.93,12.93,0,0,0,268.58,279.58Zm-54.15-4.77a12.61,12.61,0,0,0,2.21,2.42,14.46,14.46,0,0,0-3.82-5.28A12.93,12.93,0,0,0,214.43,274.81ZM241,305.64a12.92,12.92,0,0,0,2.21,2.41,12.23,12.23,0,0,0-1.6-2.85,13.29,13.29,0,0,0-2.21-2.42A13.3,13.3,0,0,0,241,305.64Zm-30.48-63a13,13,0,0,0,2.22,2.42,12.93,12.93,0,0,0-1.61-2.86,13.29,13.29,0,0,0-2.21-2.42A13.07,13.07,0,0,0,210.5,242.61Zm-5.42,19.78a12.92,12.92,0,0,0,2.41-2.21,13,13,0,0,0-2.85,1.6,13.29,13.29,0,0,0-2.42,2.21A13.3,13.3,0,0,0,205.08,262.39Zm68.29,39.06a12.92,12.92,0,0,0,2.41-2.21,12.23,12.23,0,0,0-2.85,1.6,13.29,13.29,0,0,0-2.42,2.21A13.3,13.3,0,0,0,273.37,301.45Zm-70.5-.08a13.29,13.29,0,0,0,2.42-2.21A14.14,14.14,0,0,0,200,303,13.23,13.23,0,0,0,202.87,301.37Zm49.52-46.22a12.61,12.61,0,0,0,2.42-2.21,13.3,13.3,0,0,0-2.86,1.6,12.64,12.64,0,0,0-2.41,2.22A12.63,12.63,0,0,0,252.39,255.15Zm-21.23,67.16a13.29,13.29,0,0,0,2.42-2.21,13.3,13.3,0,0,0-2.86,1.6,12.92,12.92,0,0,0-2.41,2.21A12.6,12.6,0,0,0,231.16,322.31Zm6.7-41.4a13.29,13.29,0,0,0,2.42-2.21,12.5,12.5,0,0,0-2.86,1.6,13.29,13.29,0,0,0-2.42,2.21A13.3,13.3,0,0,0,237.86,280.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.69,248.94c-7.85,21.63-37.46,70.24-47.46,71.51-2.69.34-11.33,1-15.68-1.84-13.06-8.45-23.71-36.4-29.66-56.54-2.1-7.09,30.33-16.69,34.13-9.87,2.28,4.09,10,27.44,11.21,26.87,6.27-3,34-38.95,37.86-41.91C241.43,228.37,242.64,240.81,239.69,248.94Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.12,255.57s1-13.61,1.29-22.55c.14-5-.37-13.55-1.94-17.25-2.35-5.55-15.71-27.26-21.05-24.13-4.82,2.83,9,20,9,20S156,193.08,150.82,197.55s13,21.82,13,21.82S150.65,200.57,146,206c-3.49,4.12,12.13,20.76,12.13,20.76s-11.46-16.08-15.24-12c-4.16,4.52,9.3,20.78,9.3,20.78-7.84,12-6.84,20.58-5.25,26.83C147.37,263.92,181.12,255.57,181.12,255.57Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,217.81c-1.38-2.24-2.77-4.51-4.34-6.61s-3.23-4.16-5-6.11a43.92,43.92,0,0,0-7.59-6.93c4.69,3.93,10.45,11.38,12,13.49s3.26,4.12,4.83,6.22C173.12,217.92,173.19,217.86,173.16,217.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.66,223.64c-1.89-2.78-3.66-5.61-5.67-8.3s-4.14-5.06-6.32-7.59c-.17-.2-.22,0-.06.16,2.08,2.62,3.8,5.21,5.85,7.85s4.2,5.22,6.14,7.93C165.63,223.73,165.69,223.68,165.66,223.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,229.8a75,75,0,0,0-9.65-12c-.17-.19-.22,0,0,.22,3.28,3.94,5.89,7,9.54,11.9C160,230,160.18,229.89,160.13,229.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.11,304.08c-1.07-2.16-2.25-4.25-3.32-6.41s-2.15-4.31-3.17-6.48a136.71,136.71,0,0,1-9.52-27.28,39.67,39.67,0,0,1-1-14.31,31.78,31.78,0,0,1,2-7.41,75.13,75.13,0,0,1,3.34-6.95c.18-.35-1.67-2.19-2-2.63-.66-.85-1.33-1.69-2-2.56a49.27,49.27,0,0,1-3.46-5.46,20.36,20.36,0,0,1-2.41-6.13c-.27-1.57.09-4,2.23-3.73A7.9,7.9,0,0,1,148,216.3a30.42,30.42,0,0,1,3.18,2.36h.05l0,0a.08.08,0,0,0,.12-.09c-1.12-1.64-2.15-3.34-3.14-5.06-.5-.86-1-1.73-1.42-2.62a7.43,7.43,0,0,1-.93-2.84,2.83,2.83,0,0,1,.75-2.19,2.74,2.74,0,0,1,2.54-.48,9.91,9.91,0,0,1,4.7,2.75s.1,0,.06-.05-.19-.23-.28-.34a.06.06,0,0,0,0-.07,20.12,20.12,0,0,1-2.39-4c-.66-1.36-1.47-3-1-4.6a2.74,2.74,0,0,1,3.42-1.81,8,8,0,0,1,2.18,1,21.58,21.58,0,0,1,2.24,1.53s.05,0,0,0c-.71-.71-1.48-1.36-2.25-2a6,6,0,0,0-2.28-1.28,3.16,3.16,0,0,0-3.95,1.7,5.87,5.87,0,0,0,.53,4.8,21.66,21.66,0,0,0,2.5,3.82,8.31,8.31,0,0,0-3.55-2.07,3,3,0,0,0-4,2.23c-.49,2.11.86,4.24,1.87,6a33.22,33.22,0,0,0,3.2,4.58,13.8,13.8,0,0,0-4.6-3.42,2.87,2.87,0,0,0-4,2.28c-.44,2.11.36,4.42,1.22,6.33a41.44,41.44,0,0,0,3.7,6.47c.78,1.14,1.62,2.25,2.49,3.32a34.29,34.29,0,0,0,2.52,2.69c-2.91,3.48-4.35,7.85-5.25,12.24a36.49,36.49,0,0,0-.06,14.2,107.94,107.94,0,0,0,3.91,14.46,128,128,0,0,0,5.49,13.73c1.17,2.51,2.4,5,3.81,7.4a72.46,72.46,0,0,0,4.52,7A.1.1,0,0,0,164.11,304.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.68,204.92A20.53,20.53,0,0,1,161.3,201a33.57,33.57,0,0,1-1.83-4.12c-.42-1.19-1.07-2.69-.64-3.95.72-2.07,3.16-1.41,4.48-.41,0,0,0,0,0,0a3.67,3.67,0,0,0-3.91-.86c-1.47.69-1.49,2.4-1.17,3.78a21.93,21.93,0,0,0,2,5,18.58,18.58,0,0,0,1.47,2.36c.58.78,1.29,1.46,1.89,2.22A.08.08,0,1,0,163.68,204.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.36,281.84c-.78-2.18-1.62-4.33-2.47-6.48s-1.75-4.29-2.67-6.41-2.07-4.35-3-6.56c0-.09-.18,0-.14.05.88,2.22,1.59,4.51,2.43,6.75s1.66,4.4,2.54,6.58,1.76,4.37,2.68,6.54,1.78,4.31,2.81,6.4c0,.08.17,0,.15-.08C195,286.34,194.17,284.08,193.36,281.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.92,240.38c14-16.83,21-9.65,17,9.48-3.76,17.89-11.75,38.94-11.75,38.94L199.55,271S216,251.16,224.92,240.38Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,252.64a13.19,13.19,0,0,0-.89,3.16,12.8,12.8,0,0,0-.14,3.28,13.59,13.59,0,0,0,.89-3.16A12.82,12.82,0,0,0,221.44,252.64Zm15.83,9.74a12.72,12.72,0,0,0-3.27-.15,12.94,12.94,0,0,0,3.15.9c.46.06.92.12,1.38.15.06-.2.11-.4.17-.6A14,14,0,0,0,237.27,262.38Zm-11.69-33.73a12.72,12.72,0,0,0-3.27-.14,13.32,13.32,0,0,0,3.16.89,12.72,12.72,0,0,0,3.27.14A13.19,13.19,0,0,0,225.58,228.65Zm17.43,12a13.1,13.1,0,0,0-1.53-2.68,13.41,13.41,0,0,0-2.22-2.43,13,13,0,0,0,1.61,2.87,12.71,12.71,0,0,0,2.13,2.34.27.27,0,0,0,.08.07C243.06,240.72,243,240.66,243,240.61Zm-28,33.76a12.19,12.19,0,0,0-2.2-2.41,13.47,13.47,0,0,0,1.6,2.85,12.58,12.58,0,0,0,2.21,2.41A12.11,12.11,0,0,0,215,274.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.29,245.42c-1.87,2.19-3.8,4.34-5.72,6.49.53-1.12,1-2.26,1.44-3.43,0,0-.06-.08-.08,0-.43.89-.89,1.76-1.3,2.65q-.28.65-.6,1.29l-.13.27c-1.5,1.68-3,3.36-4.43,5.08-1.73,2.05-3.41,4.14-5.09,6.23s-3.42,4.72-5.24,6.8c-.16.19,2.7,1.61,3,1.78s.49-.08.19-.19-2.5-1.73-2.52-1.76c1.68-2.1,3.59-4,5.34-6.08s3.49-4.07,5.19-6.15c3.45-4.23,6.65-8.64,10.08-12.89C220.42,245.43,220.33,245.36,220.29,245.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.12,262.59c-.56.9-1.15,1.79-1.65,2.72-.21.39-.41.78-.62,1.16q1.49-5.07,2.94-10.16s0-.07-.06,0c-1.89,5.47-3.79,10.93-5.57,16.43-1.71,5.25-3.68,10.54-4.84,15.93a19.59,19.59,0,0,0-2.9-1.23,14.66,14.66,0,0,0,3.15,1.84c2.21-5.19,3.79-11.16,5.44-16.55.46-1.52.9-3.05,1.35-4.57.43-.9.93-1.77,1.43-2.64s1-1.9,1.43-2.85C240.24,262.58,240.15,262.53,240.12,262.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.05,283.45c-4.23-2.83-21.93-13.8-25.92-15.92-.28-.14-.44,0-.17.18,12.45,8.78,21.68,13.32,26,15.89C230,283.67,230.15,283.52,230.05,283.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.45,271.46c-1,.72-8.26,7.49-8.53,8,0,.06,0,.14.09.11,3-1.61,7.78-7,8.56-8C200.64,271.53,200.55,271.39,200.45,271.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.52,229c-4.13,5-8.27,19.83-4.62,20.63s17.39-14.29,20-20S221.89,218.78,213.52,229Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.77,225c-.18,1.51-6.19,11.9-13,12.33-2.21.14-3.5-11.92-3.5-11.92l-.29-.87-4.17-12.16,13.61-11,2-1.48s.92,3.4,2,7.65c0,.2.11.39.16.61s.14.46.19.68c.17.64.35,1.28.51,1.93.12.49.24,1,.35,1.49s.24,1,.36,1.55A82.46,82.46,0,0,1,227.77,225Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.43,207.56a25.79,25.79,0,0,1-13.44,17l-4.17-12.16,13.61-11,2-1.48S223.33,203.31,224.43,207.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3,197.43c2.54,22.42,16.25,23.43,21.08,22.88,4.39-.5,19.26-2.76,19.06-25.32S214,166.53,203.92,167.14,182.77,175,185.3,197.43Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.56,193.61A12.08,12.08,0,0,0,190,193a2.51,2.51,0,0,0,1.36-.88.83.83,0,0,0-.18-1,2,2,0,0,0-2-.1,2.93,2.93,0,0,0-1.62,1.35A.85.85,0,0,0,188.56,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.64,191.37a13.54,13.54,0,0,1-1.56,0,2.54,2.54,0,0,1-1.58-.34.82.82,0,0,1-.18-1,2,2,0,0,1,1.85-.81,3,3,0,0,1,2,.69A.85.85,0,0,1,203.64,191.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.66,209.1c-.27.43-.51,1-1,1.18a4,4,0,0,1-1.69,0,.05.05,0,0,0-.05.09,2.08,2.08,0,0,0,2.09.34,1.63,1.63,0,0,0,.85-1.61C203.82,209,203.7,209,203.66,209.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.32,204.83s.11,2.31.31,3.38c0,.1.29.1.65,0,0,0,0,0,0,0a5.13,5.13,0,0,0,4.56-2.81.11.11,0,0,0-.19-.12,7.75,7.75,0,0,1-4.36,2.19c-.14-.28-.07-4-.24-3.95a9.51,9.51,0,0,0-2.31,1c-.38-4.81,0-9.65-.42-14.43,0-.17-.27-.18-.29,0-.78,5-.47,10.58-.21,15.56C193.89,206.3,195.93,205.09,196.32,204.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.52,198.36c0-.05-.1.09-.08.15.3,1.44.41,3.13-.81,3.85a0,0,0,0,0,0,.08C193.21,201.93,193,199.68,192.52,198.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.76,199.57a1.42,1.42,0,0,1-.32.43,1,1,0,0,1-.77.29c-.88,0-1.31-.94-1.41-1.84,0-.07,0-.11.07-.06.39.44.84.89,1.35.79a1.81,1.81,0,0,0,.85-.67A5.11,5.11,0,0,0,189.76,199.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.91,200.26a2.31,2.31,0,0,1-.32,1.18,1.66,1.66,0,0,1-1.11.72,1.51,1.51,0,0,1-1.27-.42,2.64,2.64,0,0,1-.61-1,5.47,5.47,0,0,1-.16-.7,3.4,3.4,0,0,1,.09-1.49,5.11,5.11,0,0,0,.23,1.06,5.36,5.36,0,0,0,.37.92c.3.59.75,1.06,1.25.95s.86-.56,1-1.23a11.05,11.05,0,0,0,.08-2.09A4.7,4.7,0,0,1,192.91,200.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.27,197.2c0-.06.12.06.13.12.08,1.46.43,3.13,1.8,3.49,0,0,0,.09,0,.08C201.56,200.82,201.12,198.6,201.27,197.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,197.63a1.38,1.38,0,0,0,.42.32.94.94,0,0,0,.82.08c.84-.28,1-1.26.87-2.15,0-.06-.05-.1-.08,0-.26.53-.58,1.08-1.09,1.12a1.9,1.9,0,0,1-1-.42A4.48,4.48,0,0,1,204.26,197.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,199.13a2.29,2.29,0,0,0,.62,1.05,1.63,1.63,0,0,0,1.26.4,1.5,1.5,0,0,0,1.11-.74,2.65,2.65,0,0,0,.31-1.16,5.86,5.86,0,0,0,0-.73,3.22,3.22,0,0,0-.49-1.41,4.48,4.48,0,0,1,.07,1.09,6.25,6.25,0,0,1-.11,1c-.13.65-.44,1.22-1,1.25s-1-.32-1.26-.93a10.64,10.64,0,0,1-.63-2A4.69,4.69,0,0,0,201.41,199.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.63,196.4c-5.47.89-10.37-15.51-10.95-17.52.29,1.29,1.85,8.13,1.38,8.51a5.45,5.45,0,0,1-1.77,0h0a17.47,17.47,0,0,0-.69-2.42c-.12-.37,0,.86.11,2.39l-1.06-.08a20,20,0,0,0-1.56-5.13c-.29-.62.12,2.34,0,5a66.67,66.67,0,0,0-14.73.32c-1.36.22-2.53.47-3.56.73-.41-2-.61-4.24-.66-3.75a19.69,19.69,0,0,0-.1,3.94l-1.52.43c-.71-2.84-.26-7.69-.58-6.9a20.72,20.72,0,0,0-1.36,7.61c-1.88.77-2.35,1.26-2.5.77-.28-.9-.76-9.15,4.32-16.28,5.52-7.74,18.75-12.05,28.36-3.72,0,0,7.1,2.86,9.41,9.28S226.79,195.88,223.63,196.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.55,196.87s3.43-7.88,6.91-6.79,1.87,11.83-1.53,13.94a3.81,3.81,0,0,1-5.41-1Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.93,193.15s.08.06,0,.09c-2.36,1.57-3.24,4.23-3.69,6.9a2.1,2.1,0,0,1,3-1.18c.07,0,0,.15-.05.15a2.33,2.33,0,0,0-2.36,1.31,10.91,10.91,0,0,0-.8,2.29c-.08.26-.52.22-.48-.06v-.07C221.84,199.31,223.46,194.19,226.93,193.15Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrayCuate);
export default __webpack_public_path__ + "static/media/Pray-cuate.6e23478b2225a1e39254090144456d11.svg";
export { ForwardRef as ReactComponent };